import { MenuButton, IconButton, useMenuContext, Box } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import BurgerIcon from '../../icons/BurgerIcon/BurgerIcon';
import MultiSelect from '../MultiSelect/MultiSelect';
import { useTokens } from '../../../context/TokenProvider';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
const FilterColumnMenuContent = ({ selectOptions, onApply, tooltipText, }) => {
    const tokens = useTokens();
    const { onClose } = useMenuContext();
    const buttonStyle = { w: '56px', h: '48px' };
    return (React.createElement(Box, { "data-testid": "column_menu_content" },
        React.createElement(ConditionalTooltip, { "aria-label": tooltipText, label: tooltipText, condition: !!tooltipText },
            React.createElement(MenuButton, { sx: buttonStyle, onClick: (e) => e.stopPropagation(), as: IconButton, variant: "white-grey", "data-testid": "column_menu_content__button", colorScheme: tokens.Layer01, icon: React.createElement(BurgerIcon, null), "aria-label": localise('FILTER_COLUMNS') })),
        React.createElement(MultiSelect, { filterLabel: localise('APPLY_FILTER'), groups: selectOptions, onApply: (values) => {
                onClose();
                onApply(values);
            } })));
};
export default FilterColumnMenuContent;
